import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import AppAlert from './plugins/appAlert'
import SnackTone from './plugins/snackTone'
import router from './router'
import axios from 'axios'
import store from './store'
import PageLoader from './components/Common/PageLoader'
import VueElementLoading from "vue-element-loading";
import ServerError from './components/Common/500'
import DateField from './components/Common/DateField'
Vue.component("VueElementLoading", VueElementLoading);
import { VueEditor } from "vue2-editor";
Vue.component('VueEditor', VueEditor)
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
Vue.component(VueCropper);
import CryptoJS from 'crypto-js';
Vue.use(CryptoJS)
import OtpInput from "@bachdgvn/vue-otp-input";
Vue.component("v-otp-input", OtpInput);
Vue.component('PageLoader', PageLoader)
Vue.component('ServerError', ServerError)
Vue.component('DateField', DateField)
Vue.config.productionTip = false
Vue.use(AppAlert)
Vue.use(SnackTone)

// window.axios = require('axios')
// axios.defaults.baseURL = 'https://naturecampapi.leopardtechlabs.in/'
// Vue.prototype.baseURL = "https://naturecampapi.leopardtechlabs.in/"
// Vue.prototype.mediaURL = "https://naturecampapi.leopardtechlabs.in/file/get/"
// Vue.prototype.mediaURLnew = "https://naturecampapi.leopardtechlabs.in/wp?key="

window.axios = require('axios')
axios.defaults.baseURL = 'https://naturecampapi.forest.kerala.gov.in'
Vue.prototype.baseURL = "https://naturecampapi.forest.kerala.gov.in"
Vue.prototype.mediaURL = "https://naturecampapi.forest.kerala.gov.in/file/get/"
Vue.prototype.mediaURLnew = "https://naturecampapi.forest.kerala.gov.in/wp?key=" 

// window.axios = require('axios')
// axios.defaults.baseURL = 'https://servicenaturecampapi.forest.kerala.gov.in'
// Vue.prototype.baseURL = "https://servicenaturecampapi.forest.kerala.gov.in"
// Vue.prototype.mediaURL = "https://servicenaturecampapi.forest.kerala.gov.in/file/get/"
// Vue.prototype.mediaURLnew = "https://servicenaturecampapi.forest.kerala.gov.in/wp?key="

// window.axios = require('axios')
// axios.defaults.baseURL = 'http://192.168.59.233:4001'
// Vue.prototype.baseURL = "http://192.168.59.233:4001"
// Vue.prototype.mediaURL = "http://192.168.59.233:4001/file/get/"
// Vue.prototype.mediaURLnew = "http://192.168.59.233:4001/wp?key="

// window.axios = require('axios')
// axios.defaults.baseURL = 'http://localhost:4001'
// Vue.prototype.baseURL = "http://localhost:4001"
// Vue.prototype.mediaURL = "http://localhost:4001/file/get/"
// Vue.prototype.mediaURLnew = "http://localhost:4001/wp?key="

// axios.defaults.baseURL = 'https://n0j9jtbv-4001.inc1.devtunnels.ms'
// Vue.prototype.baseURL = "https://n0j9jtbv-4001.inc1.devtunnels.ms"
// Vue.prototype.mediaURL = "https://n0j9jtbv-4001.inc1.devtunnels.ms/file/get/"
// Vue.prototype.mediaURLnew = "https://n0j9jtbv-4001.inc1.devtunnels.ms/wp?key="

// Enable sending and receiving cookies across origins
axios.defaults.withCredentials = true;

// Ensure device ID is persistently saved in localStorage and sent in headers (fallback for browsers blocking cookies)
let storedDeviceId = localStorage.getItem('device_id');
if (!storedDeviceId) {
    storedDeviceId = 'dev_' + Math.random().toString(36).substring(2) + Date.now().toString(36);
    localStorage.setItem('device_id', storedDeviceId);
}

// Send X-Device-Id header on every API request
axios.interceptors.request.use((config) => {
    config.headers['X-Device-Id'] = storedDeviceId;
    return config;
});

// Sync device_id if backend returns one
axios.interceptors.response.use((response) => {
    const backendDeviceId = response.headers['x-device-id'];
    if (backendDeviceId && backendDeviceId !== storedDeviceId) {
        localStorage.setItem('device_id', backendDeviceId);
        storedDeviceId = backendDeviceId;
    }
    return response;
});


new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')